module.exports = __webpack_public_path__ + "img/fubg.da6a07a6.png";